import { render, staticRenderFns } from "./activeBox.vue?vue&type=template&id=1587e549&scoped=true&"
import script from "./activeBox.vue?vue&type=script&lang=js&"
export * from "./activeBox.vue?vue&type=script&lang=js&"
import style0 from "./activeBox.vue?vue&type=style&index=0&id=1587e549&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1587e549",
  null
  
)

export default component.exports